<script lang="ts" setup>
const { LocalConfigurationStore } = stores()
const brands = ['visa', 'mastercard', 'american-express'] as const
const paymentsBadges = [
  '/img/payments-badges/american-express.jpg',
  '/img/payments-badges/mastercard.jpg',
  '/img/payments-badges/visa.jpg',
]
</script>

<template>
  <div class="bg-primary-500 text-white">
    <LayoutContainer
      v-if="LocalConfigurationStore?.brokerContext?.context.id"
      class="py-4"
    >
      <div class="grid items-center justify-center gap-4 md:flex md:justify-between">
        <div class="grid items-center gap-2 md:flex md:gap-4">
          <span class="font-bold">Nuestros procesadores de pago aceptan:</span>
          <div class="flex justify-center gap-2">
            <template
              v-for="brand in brands"
              :key="brand"
            >
              <SvgCcBrand
                :size="32"
                :brand="brand"
              />
            </template>
          </div>
        </div>
        <hr
          v-if="$viewport.isLessThan('md')"
          class="col-span-full border-primary-100/20"
        />
        <div>
          <div class="flex justify-center gap-2">
            <template
              v-for="badge in paymentsBadges"
              :key="badge"
            >
              <img
                :src="badge"
                class="w-[70px] rounded md:w-[50px]"
              />
            </template>
          </div>
        </div>
      </div>
    </LayoutContainer>
    <hr class="border-primary-400" />
    <LayoutContainer class="bg-primary-500">
      <div class="text-xs text-center py-2">
        Al acceder, navegar y proporcionar su información en este sitio, usted acepta y reconoce que
        la plataforma es administrada de manera exclusiva por Contigo.do.
      </div>
    </LayoutContainer>
  </div>
</template>
